import { MatrixCondition } from '@/globals/webApiTypes/elements/WebAPIDecisionToolData';
import { ConditionMethods, QuestionMethods } from '../questionMethods.types';
import {
	MatrixGivenAnswer,
	RenderedMatrixQuestion,
} from './matrixMethods.types';
import { CurrentQuestionMatrix } from './CurrentQuestionMatrix';
import { AnsweredQuestionMatrix } from './AnsweredQuestionMatrix';
import { isMatrixAnswered } from './isMatrixAnswered';
import { getMatrixAnswerListItems } from './getMatrixAnswerListItems';
import {
	addMatrixToGivenAnswers,
	addMatrixToSearchParams,
} from './addMatrixToSearchParams';

export const MatrixQuestionMethods: QuestionMethods<
	RenderedMatrixQuestion,
	MatrixGivenAnswer
> = {
	Current: CurrentQuestionMatrix,
	Answered: AnsweredQuestionMatrix,
	isAnswered: isMatrixAnswered,
	getAnswerListItems: getMatrixAnswerListItems,
	addToGivenAnswers: addMatrixToGivenAnswers,
	addToSearchParams: addMatrixToSearchParams,
};
export const MatrixConditionMethods: ConditionMethods<MatrixCondition> = {
	isMatch: ({ condition, givenAnswers }) => {
		const givenAnswer = givenAnswers.matrix.get(condition.questionId);
		if (givenAnswer == null) return true;

		const result = condition.rows.some(({ columnIds, rowId }) => {
			return columnIds.some((columnId) => {
				return givenAnswer.rows.some(
					(givenRow) =>
						givenRow.rowId === rowId && givenRow.columnId === columnId,
				);
			});
		});
		return result;
	},
	isValid: (condition) => {
		return (
			condition.rows.length > 0 &&
			condition.rows.every((row) => row.columnIds.length > 0)
		);
	},
};
